<template>
    <div>
        <ul v-if="$store.hasRight('EDIT_INBOUND_NUMBERS')" class="item-form" style="padding-bottom: 10px">
            <li class="form-label-first">{{ $t('Select Route Plan') }}</li>
            <li>
                <CicRadioGroup
                    id="access_route_type"
                    :value="routeType"
                    :options="[
                        { value: 0, label: $t('None') },
                        { value: -1, label: $t('New') },
                        { value: 1, label: $t('Existing') },
                    ]"
                    @input="handleRouteType"
                />
            </li>
            <li v-if="routeType === 1">
                <CicSelect
                    id="access_route_select"
                    :value="planId > 0 ? planId : null"
                    :options="plans.map((plan) => ({ value: plan.planId, label: plan.name }))"
                    @input="(val) => $emit('input', val)"
                />
            </li>
        </ul>
        <div v-if="planId !== 0 && !route" class="cloud-overlay"></div>
        <EditRoutePlanInner
            v-if="planId !== 0 && route"
            :editing="planId === -1 || ($store.hasRight('EDIT_INBOUND_NUMBERS') && $store.hasRight('EDIT_ROUTE_PLANS'))"
            :item="route"
            @change="updateFieldValue"
            @changeList="(val) => $emit('changeList', val)"
            @openRevisions="openRevisions"
        />
        <EditRevision
            v-if="showRevisions"
            :item="route"
            @blur="showRevisions = !showRevisions"
            @change="changeRevision"
        />
    </div>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';
    import EditRevision from '@/feature/inbound/routePlans/EditRevision';
    import EditRoutePlanInner from '@/feature/inbound/routePlans/EditRoutePlanInner';
    import { load } from '@/utils/Http';
    import CicRadioGroup from '@/components/inputs/CicRadioGroup.vue';

    export default {
        name: 'EditRoute',
        components: {
            CicRadioGroup,
            CicSelect,
            EditRevision,
            EditRoutePlanInner,
        },
        props: {
            orgId: {
                type: Number,
                required: true,
            },
            planId: {
                type: Number,
                required: true,
            },
            plans: {
                type: Array,
                required: true,
            },
            route: {
                type: Object,
                default: null,
            },
        },
        emits: ['change', 'changeList', 'input'],
        data() {
            return {
                planOptions: [],
                routeType: 0,
                showRevisions: false,
            };
        },
        created() {
            if (this.planId > 0) {
                this.routeType = 1;
            }

            this.planOptions = [{ value: 0, label: this.$t('None') }];
            if (this.$store.hasRight('ADD_ROUTE_PLANS')) {
                this.planOptions.push({ value: -1, label: this.$t('New') });
            }
            this.planOptions.push({ value: 1, label: this.$t('Existing') });
        },
        methods: {
            changeRevision(val) {
                this.showRevisions = false;
                this.$emit('input', this.planId, val);
            },
            handleRouteType(value) {
                this.routeType = value;
                if (value !== 1) {
                    this.$emit('input', value);
                }
            },
            openRevisions() {
                load('routeplan/revisions', { orgId: this.orgId, planId: this.planId }, (response) => {
                    this.showRevisions = true;
                    this.updateFieldValue('revisions', response.revisions);
                });
            },
            updateFieldValue(name, value) {
                this.$emit('change', name, value);
            },
        },
    };
</script>
